import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from '@angular/router';
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { isProtectedRoute } from '../functions/routes.function';
import { IdentityService } from './identity.service';


@Injectable()
export class InterceptorService implements HttpInterceptor {

  constructor(
    private identityService: IdentityService,
    private router: Router,
  ) { }

  /**
   * ## Interceptor Service Intercept Function [implemented from `HttpInterceptor` Interface]
   * Intercept and handle all the request/responses created in the application
   * @param httpRequest current request
   * @param next next request handler
   * @returns Observable with event or error instead
   */
  intercept(httpRequest: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let request;

    if (isProtectedRoute(httpRequest.url)) {
      const token = this.identityService.getToken();
      if (!token) {
        this.router.navigate(['/welcome']);
        return this.errorHandler(new HttpErrorResponse({ error: { message: 'SESSION_REQUIRED' }}));
      }

      request = httpRequest.clone({
        headers: httpRequest.headers.set('Authorization', token),
      });
    }
    else {
      request = httpRequest.clone();
    }

    return next.handle(request).pipe(catchError((error: HttpErrorResponse) => this.errorHandler(error)));
  }

  /**
   * ## Interceptor Service Error Handler Function
   * Map the current error with an specific action before the response return to the invoker component
   * @param error {HttpErrorResponse} Object Error
   * @returns Observable with thrown
   */
  errorHandler(error: HttpErrorResponse): Observable<never> {
    switch (true) {
      case (error.status === 401):
        error.error.message = 'Error de autenticación.';
        // maybe here we can navigate to login
        break;
      case (error.status === 403):
        break;
      case (error.status === 500):
        error.error.message = 'Ocurrió un error inesperado.';
        break;
    }
    return throwError(error);
  }

}
